<template>
  <v-layout justify-center class="nx-content-editor-preview">
    <iframe
      ref="iframe"
      :src="previewUrl"
      :style="iframeStyle"
      @load="loading = false"
      frameborder="0"
    ></iframe>
    <nx-display-mode-selector
      @input="onDisplayModeChange"
      :currentMode="displayMode"
      :displayModes="displayModes"
      :preview-url="previewUrl"
      type="content">
    </nx-display-mode-selector>
  </v-layout>
</template>

<script>
import NxDisplayModeSelector from '@/components/buttons/DisplayModeSelector';
import { displayModesContentEditor as displayConfig } from '@/modules/board/config';

export default {
  name: 'nx-entity-iframe-preview',
  components: {
    NxDisplayModeSelector,
  },
  props: {
    previewUrl: {
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      displayMode: displayConfig.defaultDisplayMode,
      displayModes: displayConfig.displayModes,
    };
  },
  computed: {
    iframeStyle() {
      return {
        'max-width': this.displayMode.width,
        'max-height': '75%',
      };
    },
  },
  methods: {
    async reload(additionalQueryParams = {}) {
      if (this.loading) {
        return;
      }
      if (this.$refs.iframe) {
        this.loading = true;
        const url = new URL(this.previewUrl);
        Object.entries(additionalQueryParams)
          .forEach(([key, val]) => {
            url.searchParams.set(key, val);
          });
        this.$refs.iframe.src = url.href;
      }
    },
    onDisplayModeChange(displayMode) {
      this.displayMode = displayMode;
    },
  },
};
</script>

<style lang="stylus" scoped>
  .nx-content-editor-preview iframe {
    width: 50vw;
    height: 80vh;
    position: fixed;
  }
</style>
